<template>
  <div class="ui middle aligned center aligned grid">
    <div class="column">
      <div class="ui blue header centered">
        <div class="content">{{ $t('pages.login.header') }}</div>
      </div>

      <form class="ui large form" @submit.prevent="login">
        <div class="ui stacked segment">

          <div class="field" :class="{ 'error' : errors.has('email') }">
            <div class="ui left icon input">
              <i class="user icon"/>
              <input type="email" name="email" :data-vv-as="$t('pages.login.form.email')" data-vv-delay="200"
                     v-model="form.body.email" :placeholder="$t('pages.login.form.email')"
                     v-validate="{ required: true, email: true }">
            </div>
            <span style="color: red;" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('password') }">
            <div class="ui left icon input">
              <i class="user icon"/>
              <input type="password" :data-vv-as="$t('pages.login.form.password')" name="password"
                     v-model="form.body.password" :placeholder="$t('pages.login.form.password')"
                     v-validate="{ required: true }">
            </div>
            <span style="color: red;" v-if="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="field">
            <div class="ui checkbox">
              <input type="checkbox" v-model="form.remember" name="remember">
              <label for="remember">{{ $t('pages.login.form.remember') }}</label>
            </div>
          </div>

          <button type="submit" class="ui fluid blue large submit button" :disabled="errors.any()">
            {{ $t('pages.login.form.button') }}
          </button>
        </div>
      </form>

      <div class="ui message centered">
        <router-link :to="{name: 'forgot'}">{{ $t('pages.login.forgotpass') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  layout: 'default',

  data() {
    return {
      form: {
        body: {
          email: '',
          password: ''
        },
        remember: false
      }
    }
  },

  methods: {
    login() {
      const redirect = this.$auth.redirect()
      this.$auth.login({
        data: this.form.body,
        rememberMe: this.form.remember,
        redirect: {name: redirect ? redirect.from.name : 'dashboard'},
        fetchUser: true,
        success(res) {
          // fetch merchant here.
          this.$store.dispatch('fetchMerchants').then(() => {
            if (this.$store.getters.Merchants && this.$store.getters.Merchants.data.length > 0) {
              this.fetchActiveMerchant(this.$store.getters.Merchants.data[0].id)
            } else if (this.$auth.user().external_user) {
              this.fetchMerchantIdForExternalUser(this.$auth.user().id).then((merchantId) => {
                this.fetchActiveMerchant(merchantId)
              })
            }
          })
        },
        error({response}) {
          if (response.data.error === 'invalid_credentials') {
            this.errors.add({
              field: 'password', msg: this.$t('pages.login.errors.invalid_credentials')
            });
          } else {
            this.errors.add({
              field: 'password', msg: this.$t('pages.login.errors.something_went_wrong')
            });
          }
        }
      })
    },

    fetchActiveMerchant(id) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fetchMerchant', id).then(() => {
          // return active merchant
          resolve(this.$store.getters.activeMerchant)
        }, error => {
          reject(error)
        })
      })
    },

    fetchMerchantIdForExternalUser(user_id) {
      return new Promise((resolve, reject) => {
        this.axios.get(`users/${user_id}/merchant`).then(({data}) => {
          resolve(data)
        }).catch(() => {
          reject()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ui.middle.aligned.center.aligned.grid {
  height: 100vh;
  width: 100%;
  justify-content: center;
}

.ui.middle.aligned.center.aligned.grid > .column {
  width: 450px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue